// extracted by mini-css-extract-plugin
module.exports = {"newsletter":"Newsletter_newsletter__SaLDe","nobreak":"Newsletter_nobreak__pd_u6"};